<ng-template #menuPortal>
  <div
    [id]="menuId"
    [ngStyle]="{ 'min-width': minWidth != null ? minWidth + 'px' : null }"
    role="menu" class="menu-content"
    (keydown)="onKeydown($event)"
    (click)="onMenuClick()"
  >
    <div *ngIf="title != null && title !== ''" class="menu-heading">
      <span class="text-truncate">{{title}}</span>
    </div>
    <div class="menu-items">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
